import Layout from '@/layout';
import routerView from "@/components/otherTpl/routerView";

// 特工组
export default {
    path: '/tgz',
    component: Layout,
    redirect: '/tgz/importManage/index',
    alwaysShow: true,
    meta: {
        title: '第三方任务',
        icon: 'menu_camera',
        modules: [24000]
    },
    children: [
        // 任务导入
        {
            path: 'importManage',
            redirect: '/tgz/importManage/index',
            component: routerView,
            meta: {
                title: '任务导入',
                modules: [24001]
            },
            children: [
                {
                    path: 'index',
                    name: 'TgzImportIndex',
                    component: () => import('@/views/tgz/importManage/index'),
                    meta: {
                        breadcrumb: false,
                        title: '任务导入',
                        icon: 'spot',
                        keepAlive: true,
                        modules: [24001]
                    }
                },
                // 任务详情
                {
                    path: 'detail/:id',
                    name: 'TgzImportDetail',
                    hidden: true,
                    component: () => import('@/views/tgz/importManage/detail'),
                    meta: {
                        title: '任务详情',
                        activeMenu: '/tgz/importManage/index',
                        modules: [24001]
                    }
                },
                // 原图管理
                {
                    path: 'originalManage/:id',
                    name: 'TgzOriginalManage',
                    hidden: true,
                    component: () => import('@/views/tgz/originalManage/index'),
                    meta: {
                        title: '原图管理',
                        activeMenu: '/tgz/importManage/index',
                        modules: [24001]
                    }
                },
                // 原图详情
                {
                    path: 'originalDetail/:id/:designName',
                    name: 'TgzOriginalManageDetail',
                    hidden: true,
                    component: () => import('@/views/tgz/originalManage/originalDetail'),
                    meta: {
                        title: '原图详情',
                        activeMenu: '/tgz/importManage/index',
                        modules: [24001]
                    }
                },
                // 上刊情况
                {
                    path: 'taskupStatistics/:id',
                    name: 'TgzStatisticsDetail',
                    hidden: true,
                    component: () => import('@/views/tgz/taskupStatistics/index'),
                    meta: {
                        title: '上刊情况',
                        activeMenu: '/tgz/importManage/index',
                        modules: [24001]
                    }
                }
            ]
        },
        // 任务管理
        {
            path: 'taskupManage',
            redirect: '/tgz/taskupManage/index',
            component: routerView,
            meta: {
                title: '任务管理',
                modules: [24002]
            },
            children: [
                // 任务管理
                {
                    path: 'index',
                    name: 'TgzTaskUpIndex',
                    component: () => import('@/views/tgz/taskupManage/index'),
                    meta: {
                        breadcrumb: false,
                        title: '任务管理',
                        icon: 'spot',
                        keepAlive: true,
                        modules: [24002]
                    }
                },
                // 任务详情
                {
                    path: 'taskUpDetail/:id',
                    name: 'TgzTaskUpDetail',
                    hidden: true,
                    component: () => import('@/views/tgz/taskupManage/taskUpDetail'),
                    meta: {
                        title: '任务详情',
                        activeMenu: '/tgz/taskupManage/index',
                        modules: [24002]
                    }
                }
            ]
        }
    ]
};
